import React from 'react';
import '../css/Auth.css';
import { BRAND_NAME, BRAND_NAME_EN } from '../config/brand';

// 로그인 · 회원가입 · 본인인증 화면의 틀. 규격: docs/superpowers/specs/2026-09-14-ops-auth-toss.md.
// 연회색 바탕 위 흰 카드 한 장 — 로고, 작은 머리글, 제목, 설명, 본문, 발 순서를 모든 화면이 같게 쓴다.
export default function AuthLayout({ eyebrow, title, description, wide = false, popup = false, children, footer }) {
    return (
        <div className={`auth-page${popup ? ' auth-page--popup' : ''}`}>
            <div className={`auth-page__card${wide ? ' auth-page__card--wide' : ''}`}>
                <div className="auth-page__brand">
                    <img className="auth-page__logo" src="/img/logo.png" alt="" aria-hidden="true" />
                    <span className="auth-page__brand-text">
                        <b>{BRAND_NAME}</b>
                        <small>{BRAND_NAME_EN}</small>
                    </span>
                </div>
                {eyebrow && <p className="auth-page__eyebrow">{eyebrow}</p>}
                {title && <h1 className="auth-page__title">{title}</h1>}
                {description && <p className="auth-page__desc">{description}</p>}
                {children}
                {footer && <div className="auth-page__foot">{footer}</div>}
            </div>
        </div>
    );
}

// 본인인증 넘김 화면(요청 · 결과 처리). 로직 없이 문구만 받는다. 규격: spec D12 — 넘김 로직은 각 파일에 그대로 둔다.
export function AuthRelay({ title, description }) {
    return (
        <div className="auth-page auth-page--popup">
            <div className="auth-page__card auth-page__relay" role="status" aria-live="polite">
                <span className="auth-page__spinner" aria-hidden="true" />
                <h1 className="auth-page__title">{title}</h1>
                {description && <p className="auth-page__desc">{description}</p>}
            </div>
        </div>
    );
}
